export default "__VITE_ASSET__1CKFqG$y__"